import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import BaseGrid from '@/components/decorations/BaseGrid.vue';
	import SidebarPhysicalStrain from '@/components/check/physicalstrain/SidebarPhysicalStrain.vue';
	import ModalInvitation from '@/components/company/ModalInvitation.vue';
	import ResultPageHeader from '@/components/check/ResultPageHeader.vue';
	import {getFormattedDate} from '@/utils/date';
	import {computed, ref, Ref} from 'vue';
	import {useRoute} from 'vue-router';
	import store from '@/store';
	import NumberUtils from '@/utils/numberUtils';
	import {ICheckSectionResultStatus} from '@/types/check/ICheckResult';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckResult',
  props: {
    pageTitle: {},
    loading: { type: Boolean },
    checkEnum: {},
    checkStatus: {},
    checkSections: {},
    lastUpdatedBy: {},
    lastUpdated: {}
  },
  setup(__props: any) {

const props = __props;

	

	const router = useRoute();

	const showInvitationModal: Ref<boolean> = ref(false);

	const companyId = computed(() => NumberUtils.stringToNumber(router.params.companyId));

	const hasCoachInvited = computed(() => store.getters.hasCoachInvited(companyId.value));

	const isCompanyOwner = computed(() => store.getters.isUserCompanyOwner(companyId.value));

	const lastUpdatedDate = computed(() => getFormattedDate(props.lastUpdated));

	const lastUpdatedBy = computed(() => props.lastUpdatedBy ?? '');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGrid, null, {
    sidebar: _withCtx(() => [
      _createVNode(SidebarPhysicalStrain, {
        "function-groups": _ctx.checkSections,
        loading: _ctx.loading
      }, null, 8, ["function-groups", "loading"])
    ]),
    default: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(ResultPageHeader, {
            key: 0,
            check: _ctx.checkEnum,
            loading: _ctx.loading,
            "show-invite": isCompanyOwner.value,
            status: _ctx.checkStatus,
            title: _ctx.pageTitle,
            onShowInvitationModal: _cache[0] || (_cache[0] = ($event: any) => (showInvitationModal.value = true))
          }, _createSlots({ _: 2 }, [
            (lastUpdatedDate.value)
              ? {
                  name: "last-edited",
                  fn: _withCtx(() => [
                    _createTextVNode(" Laatste wijziging op "),
                    _createElementVNode("strong", null, _toDisplayString(lastUpdatedDate.value), 1),
                    _createTextVNode(" door "),
                    _createElementVNode("strong", null, _toDisplayString(lastUpdatedBy.value), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["check", "loading", "show-invite", "status", "title"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (isCompanyOwner.value)
        ? (_openBlock(), _createBlock(ModalInvitation, {
            key: 1,
            coachInvited: hasCoachInvited.value,
            "company-id": companyId.value,
            show: showInvitationModal.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (showInvitationModal.value = false))
          }, null, 8, ["coachInvited", "company-id", "show"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})